import React from "react";
// import Header from "./components/Header";
// import LeftDrawer from "./components/LeftDrawer";
import AppRoutes from "./components/AppRoutes";
import { connect } from "react-redux";
import { getUserLoginStatus } from "../login/LoginActions";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router";
import withStyles from "@material-ui/core/es/styles/withStyles";
import Notifications from "../../components/notifications/Notifications";
import Brand from "../../components/brand/Brand";
import ConfirmationModal from "../../components/confirmation-modal/ConfirmationModal";
// import MuiThemeProvider from "@material-ui/core/es/styles/MuiThemeProvider";
// import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { getEnv, setMainElement, getApiConfig } from "./AppActions";
import InformationModal from "../../components/information-modal/InformationModal";
import LinearProgress from "@material-ui/core/es/LinearProgress";
import LoadingBackDrop from "../../components/LoadingBackDrop";
import * as utils from "../../utils";
import NavBar from "./components/DashboardLayout/NavBar/NavBar";
import TopBar from "./components/DashboardLayout/TopBar/TopBar";
import { Hidden } from "@material-ui/core";

class App extends React.Component {
  state = { navDrawerOpen: false, isMobileNavOpen: false };

  componentWillMount() {
    const { getEnv, getUserLoginStatus, getApiConfig } = this.props;
    getUserLoginStatus();
    getEnv();
    getApiConfig();
  }

  componentDidMount() {
    const stripeScript = document.createElement("script");
    stripeScript.src = "https://js.stripe.com/v3/";
    stripeScript.id = "stripeScript";
    document.getElementsByTagName("head")[0].appendChild(stripeScript);
  }

  componentDidUpdate = () => {
    const {
      setMainElement,
      app: { mainElement },
      user: { isLogin }
    } = this.props;

    if (isLogin && utils.inPopUp()) {
      console.log("Popup will be closed");
      window.close();
    }

    if (!mainElement && this.mainElement) {
      setMainElement(this.mainElement);
    }
  };

  setMobileNavOpen = () => {
    this.setState({ isMobileNavOpen: !this.state.isMobileNavOpen });
  };

  setMobileNavClose = () => {
    this.setState({ isMobileNavOpen: false });
  };

  handleChangeRequestNavDrawer = () =>
    this.setState({ navDrawerOpen: !this.state.navDrawerOpen });

  render() {
    let { navDrawerOpen, isMobileNavOpen } = this.state;
    const { user, classes, brand, app, history, location } = this.props;
    let paneName;
    if (location && location.pathname && location.pathname !== "/") {
      paneName = location.pathname.replace("/", "");
      paneName = paneName.charAt(0).toUpperCase() + paneName.slice(1);
    }

    return (
      // <MuiThemeProvider theme={brand.id === 'BM' ? TypeAppTheme : BlueMailTheme}>
      <div style={{background: '#fff'}}>
        {user.fetching || brand.fetching ? (
          <div className={classes.progressContainer}>
            <LinearProgress
              color="primary"
              classes={{ root: classes.progressContainer }}
            />
          </div>
        ) : !user.isLogin ? (
          <Redirect to="/login" />
        ) : (
          !brand.fetching &&
          brand.id && (
            <div className={classes.root}>
              {/* <Header classes={classes} history={history} location={location}
                                    handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer}/>

                            {app.leftDrawer && <LeftDrawer navDrawerOpen={navDrawerOpen}
                                                           classes={classes}
                                                           handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer}/>} */}
              <TopBar onMobileNavOpen={this.setMobileNavOpen} />
              <NavBar
                onMobileClose={this.setMobileNavOpen}
                isMobileNavOpen={isMobileNavOpen}
                setMobileNavClose={this.setMobileNavClose}
              />
              <main
                className={classes.content}
                ref={el => (this.mainElement = el)}
              >
                <Hidden lgUp>
                  <div className="pane-name">{paneName}</div>
                </Hidden>
                <div className={classes.innerContent}>
                  <AppRoutes />
                </div>
                <Notifications />
                <ConfirmationModal />
                <InformationModal />
                <LoadingBackDrop />
              </main>
            </div>
          )
        )}
        <Brand />
      </div>
      // </MuiThemeProvider>
    );
  }
}

const drawerWidth = 240;

const styles = theme => ({
  root: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%"
  },
  appBar: {
    position: "absolute",
    marginLeft: drawerWidth,
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa",
    [theme.breakpoints.up("md")]: {
      position: "relative"
    }
  },
  content: {
    flexGrow: 1,
    backgroundColor: "#fff",
    marginTop: 64,
    overflowY: "auto",
    overflowX: "hidden",
    height: "93.6%%",
    padding: "0 12px"
  },
  innerContent: {
    height: "100%",
    padding: "16px 0"
  },
  navIconHide: {
    left: -14
  },
  menuIcon: {
    "&:focus": {
      outline: "unset !important"
    },
    right: -22
  },
  logoutIcon: {
    fontSize: "2rem"
  },
  headerTitle: {
    flex: 1,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 8
    }
  },
  progressContainer: {
    position: "absolute",
    width: "100%",
    height: "3px"
  },
  activeLink: {
    borderLeft: "4px solid rgb(66, 133, 244) !important",
    paddingLeft: "17px !important",
    color: theme.palette.primary.main + " !important"
  }
});

const mapStateToProps = ({ user, app, brand }) => ({ user, app, brand });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUserLoginStatus,
      setMainElement,
      getEnv,
      getApiConfig
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(App));



// WEBPACK FOOTER //
// ./src/containers/app/App.js